import 'react-responsive-carousel/lib/styles/carousel.min.css'
import { Carousel } from 'react-responsive-carousel'
import './ImagesCarousel.css'

interface IProps {
  images: any[]
}

function ImagesCarousel (props: IProps) {
  return (
    <div className="images-carousel">
      <Carousel>
        {props.images.map((image) => (
          <div key={image}>
            <img srcSet={image} />
          </div>
        ))}
      </Carousel>
    </div>
  )
}

export default ImagesCarousel
